// Ödeme Takibi saf iş mantığı — referans tarih PARAMETRELİ (Date.now() yok → test edilebilir).

export const CEK_YONTEMLERI = ['CEK', 'SENET'];

// Vade aging kovası. bugun: 'YYYY-MM-DD'. Dönüş: GECIKMIS | YEDI_GUN | OTUZ_GUN | ILERIDE | null
export const agingKovasi = (vadeTarihi, bugun) => {
  if (!vadeTarihi) return null;
  const vade = new Date(vadeTarihi); vade.setHours(0, 0, 0, 0);
  const ref = new Date(bugun); ref.setHours(0, 0, 0, 0);
  if (vade < ref) return 'GECIKMIS';
  const gun = Math.round((vade - ref) / 86400000);
  if (gun <= 7) return 'YEDI_GUN';
  if (gun <= 30) return 'OTUZ_GUN';
  return 'ILERIDE';
};

// Yalnız BEKLEMEDE çek/senetleri kovalara böler.
export const gruplaVadeKovalari = (odemeler, bugun) => {
  const kovalar = { GECIKMIS: [], YEDI_GUN: [], OTUZ_GUN: [], ILERIDE: [] };
  (odemeler || []).forEach(o => {
    if (!CEK_YONTEMLERI.includes(o.odeme_yontemi)) return;
    if ((o.cek_durum || 'BEKLEMEDE') !== 'BEKLEMEDE') return;
    const k = agingKovasi(o.cek_vade_tarihi, bugun);
    if (k) kovalar[k].push(o);
  });
  return kovalar;
};

// Yöntem koduna göre tutar toplamı: { CEK: 150, NAKIT: 30, ... }
export const yontemBazliToplam = (odemeler) => {
  const t = {};
  (odemeler || []).forEach(o => {
    const k = o.odeme_yontemi || 'DIGER';
    t[k] = (t[k] || 0) + (o.tutar || 0);
  });
  return t;
};

// Çek/senet durum kodu → kullanıcıya gösterilen Türkçe etiket (CSV + tablo rozeti tek kaynak).
export const CEK_DURUM_ETIKET = {
  BEKLEMEDE: 'Beklemede',
  TAHSIL_EDILDI: 'Tahsil Edildi',
  KARSILIKSIZ: 'Karşılıksız',
};

// CSV/Excel için düz, tedarikçi-adı-çözümlü satırlar.
export const odemelerToCsvRows = (odemeler, tedarikciMap = {}) =>
  (odemeler || []).map(o => ({
    'İşlem Tarihi': o.odeme_tarihi || '',
    'Tedarikçi': tedarikciMap[o.tedarikci_id] || `#${o.tedarikci_id}`,
    'Yöntem': o.odeme_yontemi || '',
    'Tutar': o.tutar || 0,
    'Çek No': o.cek_no || '',
    'Çek Vade': o.cek_vade_tarihi || '',
    'Çek Durumu': o.cek_durum ? (CEK_DURUM_ETIKET[o.cek_durum] || o.cek_durum) : '',
    'Açıklama': o.aciklama || '',
  }));
